
import  {useEffect, useState} from 'react';  
import { Link, useNavigate } from 'react-router-dom';
import paths from '../routes/paths';
import logo from "../assets/images/Logo.png"
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
//import Login from "../components/Auth/Login"
import { logoutAdmin,getLoginDetails } from '../redux/slices/AuthSlice';
import { fetchCartItems } from '../redux/slices/CartSlice';
import { fetchAppSettings } from '../redux/slices/SettingsSlice';
import { getCartId, getAuthToken, } from '../utils/auth';
import SideBarCart from './SideBarCart'
import { Tooltip } from 'react-tooltip'
import CustomerSupportIcon from '../components/svg/CustomerSupportIcon';
//import {fetchGlobalSearchDetails } from '../redux/slices/CommonSlice';
import { globalSearchClose } from '../redux/slices/CommonSlice';
const  AdminHeader = () => { 
    const [showCart, setShowCart] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);
    const [isFixed, setIsFixed] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState('Dashboard');
    const {loggedInUser} = useSelector((state:any) => state.auth)
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
    
    const token = getAuthToken(); 
    const navigate = useNavigate();
    const handleLogout = () => {
      dispatch(logoutAdmin())
      .then((userData) => {
        // Handle successful login
        //console.log("userdata", userData)
        //history.push('/dashboard');
        navigate('/');

      })
      .catch((error) => {
        // Handle login failure
        console.error('Login failed:', error);
      })
    }

  useEffect(() => {

    const cart_id = getCartId();
    cart_id !== null &&  cart_id !== '' && dispatch(fetchCartItems());
    dispatch(fetchAppSettings());

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener('scroll', handleScroll);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [dispatch]);

  useEffect(() => {
    const getLoggedinDetails = () => {
        if(loggedInUser === null){
            if(token && token !== ''){
                dispatch(getLoginDetails())
            }
        }
      }
    getLoggedinDetails();
    
  },[loggedInUser,dispatch,token])
   
  
 
  const manageMenuSelection = (menu) => {
    setSelectedMenu(menu);
    dispatch(globalSearchClose()); 
    setMobileMenu(false);
  }
 
  
  return (

    <header className="site-header mo-left header style-2">		
      <div className="header-info-bar">
        <div className="container clearfix">
          <div className="logo-header logo-dark">
            <a href={paths.home}><img src={logo} alt="logo"/></a>
          </div>
          <div className="extra-nav d-md-flex d-none m-l15">
            <div className="extra-cell">
              <ul className="navbar-nav header-right m-0">
                <li className="nav-item info-box ">
                  <div className="nav-link">
                    <div className="dz-icon">			
                      <CustomerSupportIcon/>			
                    </div>
                    <div className="info-content">
                      <span>{loggedInUser?.name}</span>
                      <h6 className="title mb-0">{loggedInUser?.role} </h6>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
            
          
        </div>
      </div>

      <div className={"sticky-header main-bar-wraper navbar-expand-lg "+ (isFixed ? 'is-fixed' : '')}>
        <div className="main-bar clearfix">
          <div className="container clearfix d-lg-flex d-block">
            <div className="logo-header logo-dark">
              <a href="/"><img src={logo} alt="logo"/></a>
            </div>
            
            <button className={"navbar-toggler  navicon justify-content-end " + (mobileMenu === true ? "open" : "collapsed")} onClick={() => (mobileMenu === true ? setMobileMenu(false) : setMobileMenu(true))} type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span></span>
                <span></span>
                <span></span>
            </button>
              
            <div className={"header-nav w3menu navbar-collapse collapse justify-content-start " + (mobileMenu === true ? 'show' : '')} id="navbarNavDropdown">
              <div className="logo-header">
                <a href="/"><img src={logo} alt="logo"/></a>
              </div>
          
              <ul className="nav navbar-nav">
               
                  <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Dashboard' ? 'active' : '')} onClick={() => manageMenuSelection("Dashboard")}> <Link to={ paths.adminDashboard} className=" text-900 ">Dashboard</Link> </li> 
                  <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Sarees' ? 'active' : '')} onClick={() => manageMenuSelection("Sarees")}> <Link to={paths.sellerSarees} className=" text-900 ">Sarees</Link> </li> 
                  <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Kurtis' ? 'active' : '')} onClick={() => manageMenuSelection("Kurtis")}> <Link to={paths.sellerKurtis} className=" text-900 ">Dresses</Link> </li> 
            
              </ul>
              
            </div>

            <div className="extra-nav">
              <div className="extra-cell">							
                <ul className="header-right">
                  
                
                {loggedInUser !== null && (
                  
                    <li className="nav-item login-link"> 
                        <a href="#!" onClick={() => handleLogout()} className=" text-900 cursor">  Logout  </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <Tooltip id="my-tooltip" />

          </div>
        </div>
      </div>

      <div className="offcanvas dz-offcanvas offcanvas offcanvas-end "  id="offcanvasRight">
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
          &times;
        </button>
        <div className="offcanvas-body">
          <div className="product-description">
            <div className="dz-tabs">
              <ul className="nav nav-tabs center" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="shopping-cart" data-bs-toggle="tab" data-bs-target="#shopping-cart-pane" type="button" role="tab" aria-controls="shopping-cart-pane" aria-selected="true">Shopping Cart
                    <span className="badge badge-light header_cart_items_count">10</span>
                  </button>
                </li> 
              </ul>
              <div className="tab-content pt-4" id="dz-shopcart-sidebar">
                <div className="tab-pane fade show active" id="shopping-cart-pane" role="tabpanel" aria-labelledby="shopping-cart" >
                  <div id="mini_cart_items_list">
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div> 
  
      <SideBarCart showCart={showCart} onClose={() => setShowCart(false)}/>
    </header>
  );
}

export default AdminHeader;

